module.exports = __webpack_public_path__ + "img/電気回路_4_1_2.7e669364.png";